import React from "react";
import Banner from '../../../assets/images/BannerAuditionAdmin.png'
import Pending from '../../../assets/images/AvatarImg.png'
import './StarApprovalUpdate.css'


const StartApprovalUpdate = () => {
  return (
    <div>
      <div className="container card card-bg border-warning p-3  my-3">
        <h4 className="text-warning fw-bold mt-3 text-center ">
          Audition Title name here
        </h4>
        <div className="photoRelative">
          <img src={Banner} className="img-fluid audioBanner my-3" alt="" />
          <h5 className="registrationDate text-white p-3 fw-bolder">
            REGISTRATION DATE JUNE 25 - JULY 30
          </h5>
        </div>

        <div className="img-bgImg my-4 p-3 rounded-3">
          <p className="text-center text-white withText ">
            <i>With: </i>{" "}
          </p>
          <div className="d-flex justify-content-center">
            <img src={Pending} className="imageWidthTwo" alt="" />
            <img src={Pending} className="imageWidth" alt="" />
            <img src={Pending} className="imageWidthTwo" alt="" />
          </div>
        </div>
        <div className="text-light justify-content-between d-flex my-3 bg-gray p-3">
          <div className="text-warning fw-bold pt-2">
            <h4>Registration Fees :</h4>
          </div>
          <div className="text-warning fw-bold ">
            <h4 className="text-light fw-bold pt-2">$ 250</h4>
          </div>
        </div>
        <h5 className="text-warning  fw-bold mt-3">
          Audition Post Description
        </h5>
        <p className="text-light mx-4">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae maiores
          veniam corporis cupiditate, aliquid consequuntur. Sit odio architecto
          nulla, autem expedita aliquam ab at reiciendis. Expedita culpa illo
          ducimus quibusdam? Lorem ipsum dolor sit amet consectetur, adipisicing
          elit. Facere dicta voluptatibus consequuntur, enim eos repudiandae
          animi hic ea ullam. Ipsa possimus assumenda, facere sequi
          exercitationem tenetur minima distinctio animi nemo? Lorem ipsum dolor
          sit amet consectetur, adipisicing elit. Iusto iste repellendus
          delectus ducimus quam ratione in, nemo vel adipisci doloribus
          veritatis, ut quidem earum odit tenetur perferendis nostrum doloremque
          fuga.
        </p>
        <div className="row justify-content-center align-items-center  my-3">
          <div className="col-md-4 my-3">
            <center>
              <div className="card BGStar justify-content-center align-items-center">
                <img src={Pending} className="ImgStar mt-4 mb-4" alt="" />
                <h5 className="text-light fw-bold">Super Star 01</h5>
                <button className="btn my-3 text-light ApprovedStar px-3">
                  Approved <i className="fa-solid fa-angles-right"></i>{" "}
                </button>
              </div>
            </center>
          </div>
          <div className="col-md-4 my-3">
            <center>
              <div className="card BGStar justify-content-center align-items-center">
                <img src={Pending} className="ImgStar mt-4 mb-4" alt="" />
                <h5 className="text-light fw-bold">Super Star 01</h5>
                <button className="btn my-3 text-light ApprovedStar px-3">
                  Approved <i className="fa-solid fa-angles-right"></i>{" "}
                </button>
              </div>
            </center>
          </div>
          <div className="col-md-4 my-3">
            <center>
              <div className="card BGStar justify-content-center align-items-center">
                <img src={Pending} className="ImgStar mt-4 mb-4" alt="" />
                <h5 className="text-light fw-bold">Super Star 01</h5>
                <button className="btn my-3 text-light PendingStar px-3 ">
                  Pending ..!
                </button>
              </div>
            </center>
          </div>
        </div>

        <div className="row my-5">
          <center>
            <button className="btn ABtn fw-bold">
              Approval Request For Manager Admin
            </button>
          </center>
        </div>
      </div>
    </div>
  );
};

export default StartApprovalUpdate;
